import {useEffect, useState} from 'react';

export const NAVBAR_DESIGN_WIDTH = 1565;
export const NAVBAR_DESIGN_HEIGHT = 60;
export const NAVBAR_DESKTOP_PADDING_TOP = 17;
const NAVBAR_VIEWPORT_GUTTER = 48;
const LG_BREAKPOINT = 1024;

/** Layout viewport width — stable with `scrollbar-gutter: stable` (unlike innerWidth). */
function getStableViewportWidth(): number {
  if (typeof document === 'undefined') {
    return NAVBAR_DESIGN_WIDTH;
  }
  return document.documentElement.clientWidth || window.innerWidth;
}

export function useNavbarViewportScale() {
  const [viewportWidth, setViewportWidth] = useState(getStableViewportWidth);

  useEffect(() => {
    const update = () => setViewportWidth(getStableViewportWidth());
    update();
    window.addEventListener('resize', update);
    const root = document.documentElement;
    const observer =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(update)
        : null;
    observer?.observe(root);
    return () => {
      window.removeEventListener('resize', update);
      observer?.disconnect();
    };
  }, []);

  const isDesktopNav = viewportWidth >= LG_BREAKPOINT;
  const scale = isDesktopNav
    ? Math.min(
        1,
        Math.max(
          0,
          (viewportWidth - NAVBAR_VIEWPORT_GUTTER) / NAVBAR_DESIGN_WIDTH,
        ),
      )
    : 1;

  return {
    scale,
    shouldScaleDesktopNav: isDesktopNav && scale < 1,
  };
}
